import React from 'react'
import convert from 'htmr'
import { FeatureImage } from 'js/components/FeatureImage'
import { lpImages } from 'js/pages/LandingPages/imageSources'
import Container from 'js/pages/LandingPages/components/Container'
import { SharedSectionProps } from './types'

const transforms = {
  transform: {
    strong: (props) => {
      return <strong className="font-bold">{props.children}</strong>
    },
  },
}
type Props = {
  title: string
  features: { text: string }[]
} & SharedSectionProps
const FeaturesBlock = ({ title, features }: Props) => {
  return (
    <section>
      <Container>
        <div className="mb-96 mt-56 rounded-8 bg-BgContent p-16 shadow-greyShadow lg:mt-64 lg:p-40">
          <h3 className="pb-16 text-14 font-demibold uppercase leading-19 tracking-1.12 lg:pb-24">
            {title}
          </h3>
          <ul className="grid gap-x-[62px] gap-y-[12px] lg:grid-cols-3">
            {features.map(({ text }, index) => (
              <li key={index} className="flex items-start pb-12">
                <FeatureImage image={lpImages.checkIcon} className="mr-8" />

                <div className="text-14 font-semiregular leading-19">
                  {convert(text, transforms)}
                </div>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  )
}

export default FeaturesBlock
